import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { Expense, ExpenseInput } from '../types/expenseTypes';

const base = crudService<Expense, ExpenseInput>('/expenses');

export const expenseService = {
  list: base.list,
  get: base.get,
  create: base.create,
  update: base.update,
  /** Expenses are never deleted: cancelling reverses the payment. */
  cancel: (id: string, reason: string) => api.post<ApiResponse<Expense>>(`/expenses/${id}/cancel`, { reason }).then((r) => r.data),
};
